import styled from 'styled-components';

const StepCounterBox = styled.section`
	height: 90px;
	padding: 40px 0 0 0;
	margin: 0 auto;
	white-space: nowrap;
	.swiper-container {
		width: 100px;

		margin: 0 auto;
		padding: 0px 8px;
	}

	span {
		color: ${({ theme }) => theme.textSpanTimeLine};
		font-size: 13px;
		font-family: ${({ theme }) => theme.fontFamilyTimeLine};
		font-weight: ${({ theme }) => theme.fontWeightTimeLine};
	}

	.status span:before {
		content: '';
		width: 14px;
		height: 14px;
		background-color: ${({ theme }) => theme.colorTimeLineStatusBefore};
		border-radius: 12px;
		border: 2px solid ${({ theme }) => theme.colorTimeLine};
		position: absolute;
		left: 50%;
		top: -5%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		transition: all 200ms ease-in;
		z-index: 999999;
	}

	.status.not-empty span:before {
		content: '';
		width: 14px;
		height: 14px;
		background-color: ${({ theme }) => theme.colorTimeLineBefore};
		border-radius: 12px;
		border: 2px solid ${({ theme }) => theme.colorTimeLine};
		position: absolute;
		left: 50%;
		top: -5%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		transition: all 200ms ease-in;
		z-index: 999999;
	}

	.status.liner span:after {
		content: '';
		width: 100%;
		height: 3px;
		background-color: ${({ theme }) => theme.colorTimeLine};
		position: absolute;
		left: 102%;
		top: -5%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		transition: all 200ms ease-in;
	}

	.status.short-liner span:after {
		content: '';
		width: 97%;
		height: 3px;
		background-color: ${({ theme }) => theme.colorTimeLine};
		position: absolute;
		left: 100%;
		top: -5%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		transition: all 200ms ease-in;
	}

	@media (max-width: 512px) {
		span {
			font-size: 12px;
		}
		.status.liner span:after {
			left: 105%;
		}
	}
	@media (max-width: 992px) {
		span {
			font-size: 12px;
		}
		.swiper-container {
			max-width: 87px;
			padding: 0px 5px;
		}
	}
`;

export default StepCounterBox;
